/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppConversationPaginatedDataSchema = z.object({
	data: z.array(
		z.object({
			candidateId: z.string(),
			candidateName: z.string().nullable(),
			campaignId: z.string().nullable(),
			campaignTitle: z.string().nullable(),
			lastMessagePreview: z.string().nullable(),
			lastMessageAt: z.string().nullable(),
			lastDirection: z.string().nullable(),
			isAutomated: z.boolean(),
			needsReply: z.boolean(),
			unreadCount: z.number(),
			optedOut: z.boolean(),
			companySlug: z.string().nullable(),
		}),
	),
	meta: z.object({
		pagination: z.object({ currentPage: z.number(), lastPage: z.number(), perPage: z.number(), total: z.number() }),
		needsReplyCount: z.number(),
		unreadConversationsCount: z.number(),
	}),
})

export type WhatsAppConversationPaginatedDataSchema = z.infer<typeof whatsAppConversationPaginatedDataSchema>
